import { axiosLasta } from 'config';
import {
    CACHE_NAME_CLIENT_PERSONNEL_ID,
    CACHE_NAME_CLIENT_PERSONNEL_LIST,
    CACHE_NAME_CLIENT_PERSONNEL_LIST_DETAILED,
} from 'services/constants/cacheNameConstants';

export const fetchClientPersonnel = async () => {
    const url = 'client/personnel/all';
    const response = await axiosLasta(url, {
        cache: {
            enabled: true,
            key: CACHE_NAME_CLIENT_PERSONNEL_LIST,
        },
    });
    return response?.data || [];
};

export const searchClientPersonnelByFullName = async ({ fullName }) => {
    const url = `client/personnel/search`;
    const response = await axiosLasta(url, {
        params: {
            fullName,
            limit: 100,
        },
        cache: {
            enabled: true,
            key: `client/personnel/search?fullName=${fullName}&limit=100`,
        },
    });
    return response?.data || [];
};

export const fetchAuthorizableClientPersonnel = async (locationId) => {
    const url = `client/personnel/authorizable?locationId=${locationId}`;
    const { data } = await axiosLasta(url);
    return data || [];
};

export const fetchClientPersonnelDetailed = async ({ page = 0, size = 20, filters = {} } = {}) => {
    const url = `client/personnel/all/detailed?page=${page}&size=${size}`;
    const response = await axiosLasta.post(url, filters, {
        cache: {
            prune: [CACHE_NAME_CLIENT_PERSONNEL_LIST_DETAILED],
        },
    });
    const data = response?.data || [];

    return {
        items: data?.values ?? [],
        totalItems: data?.totalElements ?? 0,
    };
};

export const createClientPersonnel = async (payload) => {
    const response = await axiosLasta.post('client/personnel', payload, {
        cache: {
            prune: [CACHE_NAME_CLIENT_PERSONNEL_LIST],
        },
    });
    return response?.data;
};

export const editClientPersonnel = async (payload) => {
    const response = await axiosLasta.put('client/personnel', payload, {
        cache: {
            prune: [CACHE_NAME_CLIENT_PERSONNEL_LIST],
        },
    });
    return response?.data;
};

export const fetchPersonnelAuthorizedLocations = async (personnelId) => {
    const url = `client/access-personnel/${personnelId}/locations`;
    const response = await axiosLasta(url);
    return response?.data || [];
};

export const fetchClientPersonnelById = async (id) => {
    const url = `client/personnel/id/${id}`;
    const response = await axiosLasta(url, {
        cache: {
            prune: [CACHE_NAME_CLIENT_PERSONNEL_ID],
        },
    });
    return response?.data || [];
};
